module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Redo-377d99aaba9d217acaee8540624aa739.svg";